import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { lastValueFrom } from 'rxjs';
import { AsyncPipe, CommonModule } from '@angular/common';
import { BreadcrumbsComponent, ButtonComponent, PageContainerComponent } from 'wecheer-common';
import { Advertiser, CampaignsAdvertiserAdminApiClient } from 'src/app/api/api-campaigns.service.generated';
import { ScreenService } from 'src/app/common/services/screen.service';
import { AppVersionService } from 'src/app/common/services/app-version.service';
import { MigrateUsersTabComponent } from './tabs/migrate-users-tab/migrate-users-tab.component';
import { SimulateRedeemSafeboxTabComponent } from './tabs/simulate-redeem-safebox-tab/simulate-redeem-safebox-tab.component';

@Component({
  selector: 'app-advertiser-migration-campaigns',
  templateUrl: './advertiser-migration-campaigns.component.html',
  styleUrls: ['./advertiser-migration-campaigns.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatTabsModule,
    BreadcrumbsComponent,
    ButtonComponent,
    PageContainerComponent,
    MigrateUsersTabComponent,
    SimulateRedeemSafeboxTabComponent,
    AsyncPipe
  ]
})
export class AdvertiserMigrationCampaignsComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private client = inject(CampaignsAdvertiserAdminApiClient);
  screen = inject(ScreenService);
  appVersion = inject(AppVersionService);

  advertiserId: string;
  advertiser: Advertiser;
  title = 'Migration Campaigns';
  selectedTabIndex = 0;

  private readonly availableTabs = ['migrate-users', 'simulate-redeem-safebox'];

  ngOnInit(): void {
    this.advertiserId = this.route.snapshot.params['id'];
    this.loadAdvertiser();
    this.initializeTabFromRoute();
  }

  private async loadAdvertiser(): Promise<void> {
    try {
      this.advertiser = await lastValueFrom(this.client.getAdvertiserById(this.advertiserId));
      this.title = `${this.advertiser.name} - Migration Campaigns`;
    } catch (error) {
      console.error('Error loading advertiser:', error);
      this.title = 'Migration Campaigns';
    }
  }

  onBack(): void {
    this.router.navigate(['/advertisers', this.advertiser?.id || this.advertiserId]);
  }

  onRefresh(): void {
    this.loadAdvertiser();
  }

  private initializeTabFromRoute(): void {
    const tabParam = this.route.snapshot.queryParams['tab'] || this.route.snapshot.fragment;
    if (tabParam) {
      const tabIndex = this.availableTabs.indexOf(tabParam);
      if (tabIndex >= 0) {
        this.selectedTabIndex = tabIndex;
      }
    }
  }

  onTabChange(event: MatTabChangeEvent): void {
    const tabName = this.availableTabs[event.index];
    if (tabName) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { tab: tabName },
        queryParamsHandling: 'merge'
      });
    }
  }
}
